var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 148,
    viewBox: "0 0 123 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0001 37.9004C95.0001 37.9004 78.0521 8.50019 42.2481 24.7002C39.0641 26.2002 5.4201 47.4996 27.6721 85.0996C30.9011 90.5996 61.6831 119.8 61.6831 119.8L96.3881 84.4004H71.4001L79.0361 65H122.07C122.07 65 124.036 86.6004 99.8591 109.4C98.1821 111 61.6831 147.6 61.6831 147.6C61.6831 147.6 17.1451 104.8 11.7081 96.2002C6.27111 87.6002 -7.84189 63.1998 8.93211 30.2998C10.0321 28.0998 26.5151 0.400391 61.6831 0.400391C65.2771 0.400391 102.866 0.400391 117.211 37.9004H95.0001ZM76.9531 46.2002L60.2951 89.2998L55.4361 67.7002L35.3071 62.9004L76.9531 46.2002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.c5171f0b7a0317e1ae0cadc6e67dcd70.svg";
export { ForwardRef as ReactComponent };